module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Light.ttf
// module id = 79
// module chunks = 8